export default {"src":"/_next/static/media/backToCartIcon.dfa834d4.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};